import { observable, action, flow } from 'mobx';
import { ajax } from '@clouderwork/ywk';
import mobxState from '..';
import moment from 'moment';
import { IMembersSel } from '@src/entity/company/project';
import { IOssFile } from '@src/utils/upload';

/**
 * @module:  项目新建数据
 * @author: Liang Huang
 * @date: 2019-10-16 14:37:27
 */

export interface IFile {
  attachment_id: string;
  atype: string;
  create_at: number;
  username: string;
  path: string;
  name: string;
  size: number;
  uuid: string;
  md5: string;
  full_path: string;
  file_path: string;
}

interface ICreateParam {
  name: string;
  logo: string;
  project_category: number[];
  description?: string;
  members?: string[];
  manager?: string;
  start_at?: string;
  end_at?: string;
  attachment?: string[];
}

export default class ProjectCreation {
  // 项目名称
  @observable projectName: string = '';
  // 开始时间
  @observable startTime: Date | undefined;
  // 结束时间
  @observable endTime: Date | undefined;
  // 负责人
  @observable owner: any;
  // 项目成员
  @observable members: IMembersSel[] = [];
  // 任务类型
  @observable projectCategory: number[] = [];
  // 项目描述
  @observable description: string = '';
  // 附件
  @observable files: IOssFile[] = [];

  @observable fileStatus = 'init';
  @observable createStatus = 'init';

  // // 上传附件
  // @action.bound
  // postFile = flow(function* (this: ProjectCreation, file: any) {
  //   this.fileStatus = 'pending';

  //   const formData = new FormData();
  //   formData.append('file', file);
  //   formData.append('t', 'project');

  //   try {
  //     const res = yield ajax.postFile('/company/api/attachment', formData);
  //     this.fileStatus = 'done';
  //     if (+res.error_code === 0) {
  //       // 上传成功
  //       this.files.push({
  //         ...res
  //       });
  //     }
  //     return res;
  //   } catch (error) {
  //     this.fileStatus = 'error';
  //     return error;
  //   }
  // })

  @action.bound
  create = flow(function* (this: ProjectCreation) {
    try {
      const params = {} as ICreateParam;
      params.start_at = this.startTime ? moment(this.startTime).format('YYYY-MM-DD') : ''; // 计划开始时间
      params.end_at = this.endTime ? moment(this.endTime).format('YYYY-MM-DD') : ''; // 计划结束时间
      params.description = this.description; // 项目描述
      // params.period = '5天'; //
      // params.ptype = 0; //
      // params.project_pattern = 1; //
      // params.pscope = ''
      // params.keyword = ''; //
      params.manager = this.owner.uuid; // 负责人
      params.members = this.members.map(member => member.uuid); // 项目成员
      params.attachment = this.files.map(v => v.id);
      // params.industry = 1; // 行业
      // params.priority = 1; // 优先级
      // params.project_category = this.projectCategory;
      // params.pstatus = 'having';
      params.name = this.projectName;
      params.logo = '//static.clouderwork.com/task/static/images/logo/1.png'; //

      this.createStatus = 'pending';
      const res = yield ajax.post('/company/api/projects', params);
      this.createStatus = 'done';
      if (+res.error_code === 0) {
        window.AnalysysAgent.track('btn_qyb_renwu_xjxiangmu', {
          $title: '任务协作-新建项目',
          btn_name: '新建项目'
        });
      }
      return res;
    } catch (error) {
      // console.error(error);
      this.createStatus = 'error';
      return error;
    }
  });
}
